import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createDashboard, getDashboards, updateDashboard, deleteDashboard } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useCreateDashboard = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: createDashboard,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dashboards'] });
      showNotification('success', 'Dashboard created successfully!');
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.error?.message || error?.message || 'Error creating dashboard';
      showNotification('danger', errorMessage);
    }
  });
};

export const useGetDashboards = (params) => {
  const { data, isLoading, isError, error, isSuccess } = useQuery({
    queryKey: ['dashboards', params],
    queryFn: () => getDashboards(params),
  });

  return { data, isLoading, isSuccess, isError, error };
};


export const useUpdateDashboard = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: updateDashboard,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dashboards'] });
      queryClient.invalidateQueries({ queryKey: ['statistics'] });
      showNotification('success', 'Dashboard updated successfully!');
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.error?.message || error?.message || 'Error updating dashboard';
      showNotification('danger', errorMessage);
    }
  });
};

export const useDeleteDashboard = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: deleteDashboard,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['dashboards'] });
      showNotification('success', 'Dashboard deleted successfully!');
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.error?.message || error?.message || 'Error deleting dashboard';
      showNotification('danger', errorMessage);
    }
  });
};
